// Infobulles du questionnaire quotidien (petits « i » à côté de chaque champ).
//
// Textes fournis par Zoé — repris tels quels de
// `archive/petit i questionnaire quotidien.docx`. Ils expliquent à quoi sert
// chaque donnée saisie, ce qui manquait : les champs étaient demandés sans dire
// ce qu'on en fait.
//
// Distinct de `graphInfoTexts` (qui documente les graphiques des pages Cycle /
// Mental / Sport) : mêmes composant et même style de dialogue, autre moment de
// l'app. InfoButton lit les deux tables.

export const formInfoTexts = {
  // --- Formulaire Cycle ---

  formPertes:
    "Les pertes vaginales nous permettent de savoir à peu près dans quelle phase " +
    "tu te situes et si l'ovulation est en cours ou déjà passée.",

  formTemperature:
    "Prise régulièrement au réveil, la température basale nous permet d'affirmer " +
    "avec certitude si ton ovulation est passée ou non.",

  formTestOvulation:
    "C'est un test à effectuer dans les urines (comme un test de grossesse) pour " +
    "savoir si l'ovulation approche ou a eu lieu. Il est totalement optionnel.",

  // Texte fourni par Zoé, à ne pas reformuler : il pose la condition d'usage du bouton
  // (« si tu es capable de repérer »), qui est ce qui distingue une déclaration fiable
  // d'une case cochée au hasard.
  formJourOvulation:
    "Si tu es capable de repérer ton jour d'ovulation, que tu l'as senti ou que tes " +
    "glaires cervicales t'indiquent que c'est bien ça et que tu penses que c'est le " +
    "bon jour, tu peux cocher ce bouton.",

  formSymptomesPhysiques:
    "Quelle que soit la phase dans laquelle tu te situes, quels sont les symptômes " +
    "ou inconforts physiques que tu ressens aujourd'hui ?",

  formEtatReveil:
    "Cela nous permet d'évaluer si ton sommeil a été réparateur. Comme les variations " +
    "hormonales influencent la qualité du sommeil, cette donnée aide à identifier " +
    "quelles hormones prédominent.",

  // --- Formulaire Mental ---

  formSymptomesEmotionnels:
    "Indique le ou les symptômes émotionnels qui prédominent aujourd'hui, qu'ils " +
    "soient ponctuels, inhabituels ou potentiellement liés à ton cycle.",

  // --- Formulaire Sport ---

  formRpe:
    "L'échelle RPE évalue l'effort perçu lors de ton entraînement, de 1 (très facile) " +
    "à 10 (effort maximal). Au fil du cycle, cela permet de déterminer tes zones de " +
    "force et de fatigue et de les corréler à tes phases menstruelles.",

  formFrequenceCardiaque:
    "Ta fréquence cardiaque varie tout au long de ton cycle sous l'influence de tes hormones.",

  formEssoufflement:
    "Tout comme la fréquence cardiaque, ton niveau d'essoufflement à l'effort varie " +
    "au cours du cycle selon tes variations hormonales.",

  formMalDeDos:
    "Un mal de dos hormonal suit ton cycle : il revient aux mêmes moments, souvent " +
    "diffus, dans le bas du dos. Un mal de dos mécanique vient d'un geste, d'une " +
    "posture ou de ta charge d'entraînement. Les distinguer permet de savoir lequel " +
    "se corrèle vraiment à tes phases.",

  formBlessure:
    "Signale une blessure même un jour de repos : c'est souvent elle qui explique que " +
    "tu ne t'entraînes pas. La décrire permet de relier tes interruptions à leur cause " +
    "et de voir si elles reviennent aux mêmes moments de ton cycle.",

  formCourbatures:
    "Les courbatures apparaissent 24 à 48 h après l'effort : savoir de quel " +
    "entraînement elles datent permet de relier ta récupération à la séance qui l'a " +
    "provoquée, et de voir si elle varie selon la phase de ton cycle.",
};
